import DomainSelect from 'volta/components/domain-select';
import JsonApiInfinityModel, { decorateApiQuery } from 'volta/models/jsonapi-infinity-model';
import Workshop, { WorkshopResourceName } from 'volta/models/workshop';
import { eqFilter, inFilter, lkFilter, niFilter } from 'volta/utils/filters-utils';

import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';
import type { TWorkshopType } from 'volta/models/types/workshop';

interface WorkshopSelectArgs {
  workshopTypes?: TWorkshopType[];
  warehouseId?: string;
  scenarioId?: string;
  skuId?: string;
  strictWorkshopTypes?: boolean;
}

export default class WorkshopSelect extends DomainSelect<Workshop, WorkshopSelectArgs> {
  get idKey() {
    return 'id';
  }

  get infiniteScroll() {
    return true;
  }

  async searchPromise({ search, selected, excluded }: Record<string, any>) {
    const query: IJsonApiQuery = {
      sort: 'description,code'
    };
    const filter: IJsonApiQuery['filter'] = {};

    if (search?.length) {
      filter['q'] = lkFilter(search);
    }

    if (selected?.length) {
      filter['selectedIds'] = inFilter(selected);
    } else if (excluded?.length) {
      filter['id'] = niFilter(excluded);
    }

    if (this.args.workshopTypes?.length) {
      filter[this.args.strictWorkshopTypes ? 'workshopTypesStrict' : 'workshopTypes'] = inFilter(
        this.args.workshopTypes.map((wt) => wt.toUpperCase())
      );
    }

    if (this.args.warehouseId?.length) {
      filter['warehouseId'] = eqFilter(this.args.warehouseId);
    }

    if (this.args.scenarioId?.length) {
      filter['scenarioId'] = eqFilter(this.args.scenarioId);
    }

    if (this.args.skuId?.length) {
      filter['skuId'] = eqFilter(this.args.skuId);
    }

    query.filter = filter;

    const decoratedQuery = this.args.beforeQuery?.(query) ?? query;

    return await this.infinity.model(
      WorkshopResourceName.singular,
      decorateApiQuery(decoratedQuery),
      JsonApiInfinityModel
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    WorkshopSelect: typeof WorkshopSelect;
    'workshop-select': typeof WorkshopSelect;
  }
}
